const tryParseJson = (value) => {
  if (typeof value !== "string") return value;
  const trimmedValue = value.trim();
  if (!trimmedValue || !["{", "["].includes(trimmedValue[0])) {
    return value;
  }

  try {
    return JSON.parse(trimmedValue);
  } catch (error) {
    return value;
  }
};

const stringifyDetail = (detail) => {
  if (!detail) return "";
  const parsedDetail = tryParseJson(detail);
  if (typeof parsedDetail === "string") return parsedDetail;

  if (Array.isArray(parsedDetail)) {
    return parsedDetail.map(stringifyDetail).filter(Boolean).join(", ");
  }

  if (typeof parsedDetail === "object") {
    const message =
      parsedDetail.message ||
      parsedDetail.error ||
      parsedDetail.detail ||
      parsedDetail.error_code_message ||
      parsedDetail.error_code_title;
    const code =
      parsedDetail.account_status_code ||
      parsedDetail.status_code ||
      parsedDetail.sub_code ||
      parsedDetail.subCode ||
      parsedDetail.code;

    if (message && code) return `${message} (${code})`;
    if (message) return message;

    const rawAdditionalErrors =
      parsedDetail.additional_err || parsedDetail.additonal_err;
    const additionalErrors = Array.isArray(rawAdditionalErrors)
      ? rawAdditionalErrors.map(stringifyDetail).filter(Boolean)
      : rawAdditionalErrors
        ? [stringifyDetail(rawAdditionalErrors)].filter(Boolean)
        : [];
    if (additionalErrors.length) return additionalErrors.join(", ");

    return "";
  }

  return String(parsedDetail);
};

export const getApiErrorMessage = (error, fallback) => {
  const data = error?.response?.data;
  const message =
    stringifyDetail(data?.detail?.message) ||
    stringifyDetail(data?.detail) ||
    stringifyDetail(data?.message) ||
    stringifyDetail(data?.error) ||
    stringifyDetail(error?.message);

  return message || fallback;
};
